import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5v18l7-3 7 3V3zm-2 15l-5-2.18L7 18V5h10v13z"
}), 'BookmarkBorderSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BookmarkBorderSharp.js
// module id = 2397
// module chunks = 2